// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2BZgO","title":"Info_title__2iZGp","links":"Info_links__2crNU","link":"Info_link__3my6v","logo":"Info_logo__12H5S"};